import React from 'react';
import SafeIcon from '../common/SafeIcon';

const steps = [
  {
    title: "Instant Pick-Up (0 Rings)",
    description: "The conversational AI answers immediately with a natural human voice—day or night. No hold music, no voicemails.",
    icon: "PhoneCall"
  },
  {
    title: "Qualify & Book",
    description: "The AI answers specific service questions, captures lead details, and books appointments directly into your calendar or CRM.",
    icon: "CalendarCheck"
  },
  {
    title: "10-Second Text-Back",
    description: "If a line is ever busy, an automated, customized SMS is sent in under 10 seconds to lock in the lead before they search elsewhere.",
    icon: "MessageSquare"
  }
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 bg-slate-900/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">How AutoReception Works</h2>
          <p className="text-slate-400 max-w-2xl mx-auto">A seamless, automated pipeline designed to capture and convert every single lead.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connector Line */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-blue-600/0 via-blue-600/50 to-blue-600/0"></div>
          
          {steps.map((step, idx) => (
            <div key={idx} className="relative bg-slate-800/80 border border-slate-700 rounded-2xl p-8 text-center z-10 hover:-translate-y-2 transition-transform duration-300">
              <div className="w-20 h-20 mx-auto bg-slate-900 border-2 border-blue-500 rounded-full flex items-center justify-center mb-6 shadow-[0_0_15px_rgba(37,99,235,0.3)]">
                <SafeIcon name={step.icon} className="text-3xl text-blue-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{step.title}</h3>
              <p className="text-slate-400 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;